import { useLiveActivity } from '../hooks/useLiveActivity';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const LiveActivityFeed = () => {
  const activity = useLiveActivity();
  const [open, setOpen] = useState(true);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        className="relative w-96 max-w-[90vw]"
      >
        <div className="bg-white border border-slate-200 rounded-2xl shadow-2xl overflow-hidden">
          <div className="flex justify-between items-center px-4 py-3 border-b border-slate-200">
            <h2 className="text-lg font-semibold text-slate-700">⚡ Live Activity</h2>
            <button
              onClick={() => setOpen(!open)}
              className="text-slate-500 hover:text-slate-700 transition"
            >
              {open ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </button>
          </div>

          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="max-h-64 overflow-y-auto px-4 py-3"
              >
                {activity.length === 0 ? (
                  <p className="text-slate-400 italic text-sm">
                    Waiting for activity...
                  </p>
                ) : (
                  <ul className="space-y-2">
                    {activity.map((entry, idx) => (
                      <motion.li
                        key={idx}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: idx * 0.05 }}
                        className="text-[13px] font-mono text-slate-700 bg-slate-50 px-3 py-2 rounded-xl border border-slate-200"
                      >
                        <span className="text-indigo-500">[{entry.time}]</span>{' '}
                        Wallet{' '}
                        <span className="text-slate-900 font-semibold">{entry.wallet}</span>{' '}
                        withdrew{' '}
                        <span className="text-green-600 font-semibold">
                          {entry.amount.toFixed(2)} ETH
                        </span>
                      </motion.li>
                    ))}
                  </ul>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
};
